module.exports = __webpack_public_path__ + "static/media/section-header-3.df4901df.jpg";